import { apiFetch } from "lib/api";
import { API_ENDPOINTS } from "lib/apiUrl";

function extractUploadedUrl(resp) {
  if (!resp) return "";
  if (typeof resp === "string") return resp;

  const root = resp?.data ?? resp;
  return (
    root?.url ||
    root?.fileUrl ||
    root?.location ||
    root?.path ||
    root?.result?.url ||
    root?.result?.fileUrl ||
    ""
  );
}

/**
 * @param {File} file
 * @param {string | { path?: string; extraFields?: Record<string, string> }} [pathOrOptions]
 */
export async function uploadFile(file, pathOrOptions = API_ENDPOINTS.uploadFile) {
  let opts = {};
  if (typeof pathOrOptions === "string") {
    opts = { path: pathOrOptions };
  } else if (pathOrOptions && typeof pathOrOptions === "object") {
    opts = pathOrOptions;
  }
  const path = opts.path ?? API_ENDPOINTS.uploadFile;
  const form = new FormData();
  form.append("file", file);
  if (opts.extraFields && typeof opts.extraFields === "object") {
    for (const [key, value] of Object.entries(opts.extraFields)) {
      if (value != null) form.append(key, String(value));
    }
  }
  const resp = await apiFetch(path, { method: "POST", body: form });
  const url = extractUploadedUrl(resp);
  if (!url) {
    throw new Error("Upload succeeded but no URL was returned.");
  }
  return url;
}
